import { envHelper } from "../utils/envHelper";
import { appendFileExtension, hasExtension } from "../utils/path";

class VideoTransparentLoader {
  key = "video";

  _videoType(extension = "mp4") {
    return `video/${extension}`;
  }

  async load(assetsPath) {
    return new Promise((resolve, reject) => {
      const allowedExtension =
        envHelper.getVideoTransparentSupportedExtension();
      const src = hasExtension(assetsPath)
        ? assetsPath
        : appendFileExtension(assetsPath, allowedExtension);

      const sourceVideo = document.createElement("video");
      document.body.appendChild(sourceVideo);

      sourceVideo.type = this._videoType(allowedExtension);
      sourceVideo.muted = true;
      sourceVideo.playsinline = true;
      sourceVideo.crossOrigin = "anonymous";
      sourceVideo.preload = "metadata";

      sourceVideo.addEventListener("loadedmetadata", () => {
        // TODO chrome does not always dispatch this event
        // it is probably/hopefully only when running locally
        // still, has to be addressed

        document.body.removeChild(sourceVideo);
        resolve({
          content: sourceVideo,
          representation: {
            videoWidth: sourceVideo.videoWidth,
            videoHeight: sourceVideo.videoHeight,
            length: sourceVideo.duration * 1000,
          },
        });
      });

      sourceVideo.addEventListener("error", () => {
        document.body.removeChild(sourceVideo);
        console.warn(`[AssetLoader] Failed to load video: ${src}`);
        reject(new Error(`Video not found: ${src}`));
      });

      sourceVideo.src = src;
    });
  }
}

const videoTransparentLoader = new VideoTransparentLoader();
export { videoTransparentLoader, VideoTransparentLoader };
